import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@/state/session'

import { subscriptionKeys } from '../api/keys'
import { fetchSubscriptionStatus } from '../api/get-subscription-status'

export function useSubscriptionStatus() {
  const auth = useAuth()
  const userId = auth.isAuthenticated ? auth.user.profile.id : null

  return useQuery({
    queryKey: subscriptionKeys.status(userId),
    queryFn: fetchSubscriptionStatus,
    enabled: auth.isAuthenticated,
    refetchOnWindowFocus: false,
  })
}
